import Modal from 'react-modal';
import { useIntl } from 'react-intl';
import Loading from 'react-loading';

import { useLoading } from '@/hooks/useLoading';
import { sharedText } from '@/translations/shared';

Modal.setAppElement( '#__next' );

const styles = {
	content: {
		width: '175px',
		height: '150px',
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		margin: 'auto'
	}
};

export default function LoadingModal() {
	const { formatMessage } = useIntl();

	const { currentModal } = useLoading();

	if ( !currentModal ) {
		return null;
	}

	return (
		<Modal
			isOpen={ true }
			style={ styles }
			contentLabel={ formatMessage( sharedText.loading ) }
		>
			<div className="flex flex-col justify-center items-center h-full">
				<Loading type="spin" color="#676767" width={ 32 } height={ 32 } />

				<span className="mt-3 text-gray-500 text-sm italic text-center">{ currentModal.modalText }</span>
			</div>
		</Modal>
	);
}
